import { ReactNode, createContext, useContext } from 'react';
import { Shift } from '@sdk/automatedBreaks/types/Shift';

import { AutomatedBreaksContextType } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/automatedBreaksProvider.types';
import { useAutomatedBreaks } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/automatedBreaksProvider.hooks';
export const AutomatedBreaksContext = createContext<AutomatedBreaksContextType>(
  null as AutomatedBreaksContextType
);

type Props = {
  children: ReactNode;
  startAutomatedBreak: VoidFunction;
  shift: Shift;
};

export const useAutomatedBreaksContext = () => {
  const context = useContext(AutomatedBreaksContext);

  if (!context) {
    throw new Error('AutomatedBreaksContext must be used within a AutomatedBreaksProvider');
  }

  return context;
};

export const AutomatedBreaksProvider = ({ children, startAutomatedBreak, shift }: Props) => {
  const value = useAutomatedBreaks({ shift, startAutomatedBreak });

  return (
    <AutomatedBreaksContext.Provider value={value}>{children}</AutomatedBreaksContext.Provider>
  );
};
